// @ass/js/secretManager.js
import axios from "axios";
import Qs from "qs";
import JSEncrypt from "jsencrypt";

// ★ 写死 account 域名（末尾必须带 /）
const ACCOUNT_URL = "https://account.duoduiduo.com/";

// ★ 写死 RSA 公钥（PEM 格式，真实换行）
const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvBR9kMyg51BQKSlNb2Ey
vcwxG9W4yIaDtyyJ5DR+LTEuYyZczLsCs8CW+OguEZJ8lqiay33ZOR+vA/cjx+l8
vm2HXmcvyjqteCQFREfQTyYMEJwOCPo32iBUgyCb0rSPFjroL7/wuTbWfOrrvFDM
blQ9lLlF7VPfT+V7jmH1N8DNlDFnSgMJ9aQ8cN4IhZAWrtvbEZtXco7hEv13NBz4
KTt4rZJLDMza8CbtzE8MqX4qOHxBukIJBicsnIT3Cn7FSE1avE5qu9IRJvM0xn9I
rzmCUrOfrEjBtwAPkL8SFCUxysKM4Vyvy7HRT+T7K/1XSh6S7PxkcJnqKj+XqzUL
0wIDAQAB
-----END PUBLIC KEY-----`;

// 临时密钥有效期 5 分钟，提前 15 秒主动刷新
const SECRET_TTL = 5 * 60 * 1000 - 15 * 1000;

// ★ 写死 app_id（和业务接口保持一致，按你实际值改）
const FIXED_APP_ID = "867520190510168";

let secretCache = null; // 缓存 getsecret 返回的临时密钥（明文）
let secretCacheTime = 0;
let secretPromise = null; // 并发去重

function getAppId() {
  const app_id = window.localStorage.getItem("app_id");
  if (app_id && app_id !== "null") return app_id;
  return FIXED_APP_ID;
}

function rsaEncrypt(text) {
  if (!RSA_PUBLIC_KEY) {
    console.warn("[secret] 未配置公钥，RSA 加密跳过");
    return "";
  }
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(RSA_PUBLIC_KEY);
  const result = encryptor.encrypt(text);
  if (!result) {
    console.error("[secret] RSA 加密失败：检查公钥格式/位数/明文长度");
    return "";
  }
  return result;
}

// POST /api/getsecret { app_id } → 取 res.data.data.secret（明文）
function fetchSecret() {
  return axios({
    url: `${ACCOUNT_URL}api/getsecret`,
    method: "post",
    data: Qs.stringify({ app_id: getAppId() }),
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  }).then(res => {
    const body = res.data || {};
    const tempSecret = body.data && body.data.secret;
    if (!tempSecret) {
      throw new Error(
        "[secret] getsecret 未返回 data.secret：" + JSON.stringify(body)
      );
    }
    secretCache = tempSecret;
    secretCacheTime = Date.now();
    return tempSecret;
  });
}

/**
 * 对外唯一入口：返回 { plain, encrypted }
 * - plain：临时密钥明文，用于 sign 的 app_secret
 * - encrypted：RSA 加密后的密文，用于业务参数 secret 字段
 */
export function getSecretInfo() {
  const pack = plain => ({
    plain,
    encrypted: rsaEncrypt(plain)
  });

  if (secretCache && Date.now() - secretCacheTime < SECRET_TTL) {
    return Promise.resolve(pack(secretCache));
  }

  if (!secretPromise) {
    secretPromise = fetchSecret()
      .then(plain => {
        secretPromise = null;
        return pack(plain);
      })
      .catch(err => {
        secretPromise = null;
        throw err;
      });
  }
  return secretPromise;
}

export function clearSecret() {
  secretCache = null;
  secretCacheTime = 0;
  secretPromise = null;
}


// WEBPACK FOOTER //
// ./src/assets/js/secretManager.js